'use client';

import { SessionProvider } from 'next-auth/react';

export function PublicProviders({ children }: { children: React.ReactNode }) {
  return <SessionProvider>{children}</SessionProvider>;
}

